import { combineReducers, compose, createStore } from "redux";
import filterFormData from "./reducers/filterFormData";
import products from "./reducers/products";
import creditCardFilterFormData from "./reducers/creditCardFilterFormData";
import loanAmountFormData from "./reducers/loanAmountFormData";
import loanFormData from "./reducers/loanFormData";
import loanFilterFormData from "./reducers/loanFilterFormData";

const composeEnhancers =
  typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

export default () =>
  createStore(
    combineReducers({
      filterFormData,
      products,
      loanAmountFormData,
      creditCardFilterFormData,
      loanFormData,
      loanFilterFormData
    }),
    {
      filterFormData: {},
      creditCardFilterFormData: { bank: { allValues: true } },
      products: [],
      loanAmountFormData: {},
      loanFormData: {},
      loanFilterFormData: { bank: { allValues: true } }
    },
    composeEnhancers()
  );
